import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {DateRangeSelector} from 'mindsets-js-sdk';

import SAMMenu from 'common/SAMMenu'
import SchoolFilter from 'common/spam/SchoolFilter'
import ChallengeFilter from 'common/spam/ChallengeFilter'
import EngagementStageLegend from 'common/EngagementStageLegend'
import SchoolTeacherData from './SchoolTeacherData'
import useAuth from "../../hooks/useAuth";
import Forbidden from "../Forbidden";
import {isEducator} from "utils/role";
import {userCan} from "utils/membership";
import {SetPAMFromAction, SetPAMTillAction} from "../../actions/pam_actions";

export default function () {
    useAuth(['teacher']);

    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const from = useSelector(state => state.pam_from);
    const till = useSelector(state => state.pam_till);

    function renderMain() {
        return (
            <div className="section">
                <SchoolTeacherData/>
            </div>
        );
    }

    function renderContent() {
        if (me && isEducator(me) && me.permissions.includes('can_see_sam') && userCan(me.subscription_status, 'see_sam')) {
            return (
                <div id="engagement-dashboard">
                    <div id="sam-teacher" className="container">
                        <div className="section">
                            <SAMMenu/>
                        </div>

                        <div className="section">
                            <div className="flex-row flex-box-10-10">
                                <div>
                                    <SchoolFilter/>
                                </div>

                                <div>
                                    <DateRangeSelector
                                        from={from}
                                        till={till}
                                        onUpdate={data => {
                                            dispatch(SetPAMFromAction(data.from));
                                            dispatch(SetPAMTillAction(data.till));
                                        }}
                                    />
                                </div>

                                <div>
                                    <ChallengeFilter school_required={false}/>
                                </div>
                            </div>
                        </div>

                        <div className="flex-row flex-h-end">
                            <EngagementStageLegend/>
                        </div>

                        {renderMain()}
                    </div>
                </div>
            );
        } else if (me && (!isEducator(me) || !me.permissions.includes('can_see_sam') || !userCan(me.subscription_status, 'see_sam'))) {
            return (
                <Forbidden/>
            );
        }

        return null;
    }

    return (
        <>
            {renderContent()}
        </>
    );
}
